import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import StbPurchase from "../components/stbpurchase.jsx";
import Footer from "../components/footer.jsx";

function StbPurchasepage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <StbPurchase/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default StbPurchasepage;
